import { Card, Flex, Text, Box, Progress, Badge } from '@radix-ui/themes';
import { DateTime } from 'luxon';
import { formatDate } from '../../../utils/dateUtils'; // You'll need to create this
import CircleProgress from '../../shared/CircleProgress';

const PeriodOverview = ({ periods = [], onSelect }) => {
    if (!periods || periods.length === 0) {
        return <Text size="1">No active periods</Text>;
    }
    return (
        periods.length > 0 ? (
            <Flex direction="row" gap="3" wrap="wrap">
                {periods.map((period) => {
                    if(period.teaching_plan_stats.length == 0) {
                        return (
                            <Card key={period.id}>
                                <Flex direction="row" justify="start" align="center" gap="3">
                                    <Box>
                                        <CircleProgress
                                            progress={0}
                                            size={80}
                                            strokeWidth={5}
                                            label={`0%`}
                                            labelSize="4"
                                        />
                                    </Box>
                                    <Box>
                                        <Text weight="bold" size="1" as="p">{period.title}</Text>
                                        <Text size="1" as="p">No active teaching plans</Text>
                                    </Box>
                                </Flex>
                            </Card>
                        );
                    }
                    var period_performance = period.teaching_plan_stats.length > 0 ? 
                        period.teaching_plan_stats.reduce((acc, curr) => 
                            ({
                                average_score:acc.average_score + curr.average_score,
                                average_completion_rate: acc.average_completion_rate + curr.completion_rate,
                                // average_participation_count: acc.average_participant_count + curr.participant_count
                            }), {average_score:0, average_completion_rate:0})
                    :
                    {average_score:0, average_completion_rate:0}

                    period_performance = {
                        ...period_performance, average_score:period_performance.average_score/period.teaching_plan_stats.length,
                        // average_participant_count:period_performance.average_participation_count/period.stats.length,
                        average_completion_rate: period_performance.average_completion_rate/period.teaching_plan_stats.length
                    }

                    return (
                        <Card key={period.id} style={{flex:1, cursor:'pointer'}} onClick={() => onSelect(period.id)} >
                            <Flex direction="row" justify="between" align="center" gap="2">
                                <Flex direction="row" justify="start" align="center" gap="3">
                                    <Box>
                                        <CircleProgress
                                            progress={period_performance.average_score}
                                            size={80}
                                            strokeWidth={5}
                                            label={`${Math.floor(period_performance.average_score)}%`}
                                            labelSize="4"
                                        />
                                    </Box>
                                    <Flex direction="column" gap="1">
                                        <Text weight="bold" size="1" as="p">{period.title}</Text>
                                        <Text size="1" as="p">Average Score: {period_performance.average_score}</Text>
                                        <Text size="1" as="p">Average Completion:</Text>
                                        <Progress color="blue" value={period_performance.average_completion_rate} style={{maxWidth:'100px'}}/>
                                    </Flex>
                                </Flex>
                                <Flex direction="column" gap="2">
                                    <Text size="1" align="right">Teaching plans: <Badge variant="solid" color="blue">{period.teaching_plan_stats.length}</Badge></Text>
                                    <Text size="1" align="right">Topics: <Badge variant="solid" color="grass">{period.teaching_plan_stats.reduce((acc, curr) => (acc + curr.completed_topics), 0)}</Badge> | <Badge variant="solid" color="blue">{period.teaching_plan_stats.reduce((acc, curr) => (acc + curr.total_topics), 0)}</Badge></Text>
                                </Flex>
                            </Flex>
                        </Card>
                    );
                }
                )}
            </Flex>
        ) : (
            <Text size="1">No active periods</Text>
        )
    );
};

export default PeriodOverview;